import {Link, useNavigate} from "@tanstack/react-router";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import nacl from "tweetnacl";
import { signUp } from '../../../lib/api';
import { useI18n } from '../../../i18n/context';
import {from} from "../../../utils/browser-buffer";
import {useAppKitAccount, useAppKit, useAppKitProvider, useDisconnect} from '@reown/appkit/react';
import { useAuth } from '../../../lib/auth';
import { sessionStorageGet, sessionStorageSet, sessionStorageRemove } from '../../../lib/window-shim';

function toBase64(uint8Array) {
    const binary = String.fromCharCode.apply(null, Array.from(uint8Array));
    return btoa(binary);
}


const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

const SecForm = ({callback, type, formStrings}) => {
  const { t } = useI18n();
    const [username, setUserName] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [/*errorMessage,*/ setEM] = useState('')
    const {wallet/*, open, close*/} = useAppKit()
    const navigate = useNavigate();
    const {isConnected, address} = useAppKitAccount();

    useEffect(()=>{}, [address,isConnected])

    async function handleSubmit(e, setEM, address) {
        e.preventDefault();

        //console.log(this.state.username);
        let bad = false;
        if (!isConnected && type === "evm") {
            toast(t("signUp.errorWalletDisconnected"), {type: "error", autoClose: 30000});
            bad = true;
        }
        if (username.length < 4) {
            toast(t("signUp.errorUsernameShort"), {type: "error", autoClose: 30000});
            bad = true;
        }
        if (!validateEmail(email)) {
            toast(t("signUp.errorInvalidEmail"), {type: "error", autoClose: 30000});
            bad = true;
        }
        if (password.length < 8) {
            toast(t("signUp.errorPasswordShort"), {type: "error", autoClose: 30000});
            bad = true;
        }
        if (bad === false) {
            let evmSig = sessionStorageGet("evmSignature") ?? null
            let evmNon = sessionStorageGet("evmNonce") ?? null
            let walletAddr = wallet?.accounts[0].address;
            /*let token = */
            await signupUser({
                username,
                password,
                email,
                evmSig,
                walletAddr: address,
                evmNon,
                type
            }).catch(err => {
                callback(err)
            }).then(token => {
                let vars = JSON.stringify(token)
                if (token.auth === false) {
                    toast(token.message || t('signUp.errorGeneric'))
                } else {
                    if (type === "evm") {
                        sessionStorageSet("token", JSON.stringify({auth: true, account: token.account[0]}))
                        sessionStorageSet("authKey", token.authToken);
                        navigate({ to: "/profile", state: { flag: "newuser" } });
                        toast.success(t("signUp.successRegistration"), {autoClose: 5000});
                    } else {
                        toast.info(t("signUp.checkEmail"));
                        navigate({ to: "/" });
                    }
                }

                callback(vars)

            })
        }
    }

    return (
        <div className="col-lg-5 col-md-7 mx-auto mb-30">
            <div className="rela card card-purple ms-2 me-2 z-index-0">
                <div className="card card-purple text-center text-light pt-2">
                    {/* <h5 className="text-light">Sign in Now</h5>*/}
                    {type === 'email' ? t('signUp.titleEmail') : address ? `${t('signUp.titleWallet')} ${address.substr(0, 6)}...${address.substr(-4)}` : t('signUp.errorWalletMissing')}
                </div>

                <div className="card-body">
                    <div className="mb-3 mt-3"></div>

                    <form autoComplete="one-time-code" onSubmit={(e)=>handleSubmit(e, setEM, address)}>
                        <div className="mb-3">
                            <input value={username} autoComplete="off" id="lin" name="lin" type="text"
                                   className="input-purple w-100" placeholder={formStrings.nameText || t("signUp.name")}
                                   aria-label="Name"
                                   onChange={e => setUserName(e.target.value)}/>
                        </div>
                        <div className="mb-3">
                            <input value={email} id="lemail" name="lemail" type="email" className="input-purple w-100"
                                   placeholder={formStrings.emailText || t("signUp.email")}
                                   aria-label="Email"
                                   onChange={e => setEmail(e.target.value)}/>
                        </div>
                        <div className="mb-3">
                            <input autoComplete="new-password" value={password} id="lpasswd" name="lpasswd"
                                   type="password" className="input-purple w-100" placeholder={formStrings.pwText || t("signUp.password")}
                                   onChange={e => setPassword(e.target.value)}/>
                        </div>
                        <div className="form-check form-check-info text-left">
                            <input className="form-check-input" type="checkbox" value="" checked/>
                            <label className="form-check-label text-light">
                                I agree to the <Link to="/" className="text-warning font-weight-bold">{t("signUp.termsPrefix")} {t("signUp.termsLink")}</Link>
                            </label>
                        </div>
                        <div className="text-center">
                            <button className="bg-gradient-warning raisedBoxPurple  w-100 my-4 p-2 mb-2">{t('signUp.submit')}
                            </button>
                        </div>
                        <div className="text-sm mt-2 mb-0">Already have an accounnt?&nbsp;&nbsp;&nbsp;
                            <Link to="/signin" className="text-warning font-weight-bolder">{t("signUp.signIn")}</Link></div>
                    </form>
                </div>
            </div>
        </div>

    );
}

async function signupUser(credentials) {
    try {
        const hash = nacl.hash(from(credentials.password, "utf-8"));
        credentials.password = toBase64(hash);
    } catch (e) {
    }

    return await signUp(credentials)
}


export default SecForm;
